import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-zatca-invoice-list',
  templateUrl: './zatca-invoice-list.component.html',
  styleUrls: ['./zatca-invoice-list.component.css']
})
export class ZatcaInvoiceListComponent implements OnInit {

  menu_id = '1';
  public menu_item_id = '124';
  public add_auth;
  public edit_auth;
  public del_auth;

  model = {
    'table_name': 'invoice', 'from_date': new Date(), 'to_date': new Date(), 'invoice_type': 'all', 'zatca_status': '0',
    'title': 'قائمة قواتير الزكاة'
  };

  invoice_type = [{ 'value': 'all', 'type_name': 'الكل', 'type_name_en': 'All' },
    { 'value': 'invoice', 'type_name': 'فواتير المبيعات', 'type_name_en': 'Sales Invoices' },
    { 'value': 'return_invoice', 'type_name': 'مرتجعات المبيعات', 'type_name_en': 'Return Sales Invoices' }];

  statusList = [{ 'status_id': '0', 'status_name': 'الكل', 'status_name_en': 'All' },
    { 'status_id': '', 'status_name': 'بانتظار الإرسال من المكلف', 'status_name_en': 'Waiting for the sender to send' },
    { 'status_id': 'NOT REPORTED', 'status_name': 'خطأ في الإرسال', 'status_name_en': 'Not Reported' },
    { 'status_id': 'REPORTED', 'status_name': 'تم الإرسال', 'status_name_en': 'Reported' },
    { 'status_id': 'CLEARED', 'status_name': 'مقبولة', 'status_name_en': 'Cleared' },
    { 'status_id': 'REJECTED', 'status_name': 'مرفوضة', 'status_name_en': 'Rejected' }];

  private dp = [];
  displayedColumns = ['choose', 'invoice_id', 'invoice_no', 'invoice_date', 'customer_name', 'invoice_type',
    'total', 'pay_status', 'payment_method', 'zatca_status', 'zatca_error'];  // , 'zatca_warning'

  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  displayedColumns2 = ['invoice_id', 'invoice_no', 'invoice_date', 'customer_name', 'invoice_type',
    'total', 'pay_status', 'payment_method', 'zatca_status', 'zatca_error'];  // , 'zatca_warning'

  from_date;
  to_date;
  total = 0;

  From_Date; To_Date; Zatca_Invoice_List; 
  Success_Msg; Error_Msg; 
  Customer_Name; Type; Mobile; Status; Search_Msg; Ret_No_Msg;
  Cancel_Invoice_Msg; Ret_All_Msg; Amount_Total;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private route: ActivatedRoute, private router: Router, 
    public dialog: MatDialog, public translate: TranslateService) { 
    
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    });

    translate.get('Zatca_Invoice_List').subscribe((res: string) => {
      this.Zatca_Invoice_List = res;
    });
    this.model['title'] = this.Zatca_Invoice_List;

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });
    
    translate.get('Ret_All_Msg').subscribe((res: string) => {
      this.Ret_All_Msg = res;
    });

    translate.get('Customer_Name').subscribe((res: string) => {
      this.Customer_Name = res;
    });

    translate.get('Type').subscribe((res: string) => {
      this.Type = res;
    });

    translate.get('Mobile').subscribe((res: string) => {
      this.Mobile = res;
    });

    translate.get('Status').subscribe((res: string) => {
      this.Status = res;
    });

    translate.get('Search_Msg').subscribe((res: string) => {
      this.Search_Msg = res;
    });

    translate.get('Ret_No_Msg').subscribe((res: string) => {
      this.Ret_No_Msg = res;
    });

    translate.get('Cancel_Invoice_Msg').subscribe((res: string) => {
      this.Cancel_Invoice_Msg = res;
    });
    
    translate.get('Amount_Total').subscribe((res: string) => {
      this.Amount_Total = res;
    });
  }

  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);
  }

  search() {
    this.dp = [];
    this.total = 0;

    if (this.model['from_date'] == undefined && this.model['to_date'] == undefined && 
      this.model['invoice_type'] == 'all' && this.model['zatca_status'] == '0') {
      alert(this.Search_Msg);
      return;
    }

    let obj = { cmd: 'getIncomeReport' }; 
    
    if (this.model['from_date'] != undefined) 
      obj['from_date'] = this.model['from_date'].getFullYear() + "-" + 
        (this.model['from_date'].getMonth() + 1) + "-" + this.model['from_date'].getDate() + ' 00:00:00';

    if (this.model['to_date'] != undefined) 
      obj['to_date'] = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + 
        "-" + this.model['to_date'].getDate() + ' 23:59:59';

    if (this.model['invoice_type'] != 'all')
      obj['invoice_type'] = this.model['invoice_type'];

    if (this.model['zatca_status'] != '0')
      obj['zatca_status'] = this.model['zatca_status'];

    this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        console.log(data);
        if (data.status['type'] == 'success') {
          this.dp = data.status['msg'][0]['list'];
          this.total = data.status['msg'][0]['total'];
        }
        else
          alert(this.applicationConstants.user_lang == 'ar' ? data.status['msg'][0]['msg_ar'] : data.status['msg'][0]['msg_en']);

        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  choose_all() {
    let choose_all = document.getElementById('choose_all') as HTMLInputElement;

    this.dp.forEach(element => {
      if (element.zatca_status == '') {
        let choose = document.getElementById('choose_' + element.invoice_no) as HTMLInputElement;
        choose.checked = (choose_all.checked);
      }
    });
  }

  sendToZatca() {
    let values = [];

    this.dp.forEach(element => {
      let choose = document.getElementById('choose_' + element.invoice_no) as HTMLInputElement;
      console.log(choose);
      if (choose && choose.checked) {
        values.push({ 'invoice_no': element.invoice_no, 'type':element.type });
      }
    });

    if (values.length > 0) {
      let obj = { cmd: 'sendInvZatca', invoice_list: values };
      this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            //console.log(data.status['type']);
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

  print() {
    let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
      this.model['from_date'].getDate();
    let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
      this.model['to_date'].getDate();

    let html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"><h2>' + this.Zatca_Invoice_List + '</h2></td></tr>';
    html_data += '<tr><td width="33%"> ' + this.From_Date + ': ' + from_date + '</td><td width="33%"> ' + this.To_Date + ': ' + to_date + '</td></tr>';
    html_data += '<tr><td width="33%"> ' + this.Amount_Total + ': ' + this.total + '</td></tr>';
    html_data += '</table>';

    let form = (document.getElementById('form1') as HTMLFormElement);
    let table = (document.getElementById('invoice_table2') as HTMLTableElement);
    this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
